import React from 'react';
import Question from '../Components/Question';
import { Button } from 'semantic-ui-react';

function UnaffectedCancerType() {
    return Question({
        question: "Which type of cancer should the patient be tested for?",
        wrapper: (children => <Button.Group vertical>{children}</Button.Group>),
        answers: [
            {
                link: "/unaffected/breast",
                text: "Breast cancer",
                properties: {
                    color: 'pink',
                    fluid: true
                }
            },
            {
                link: "/unaffected/ovarian",
                text: "Overian cancer",
                properties: {
                    color: 'purple',
                    fluid: true
                }
            },
            {
                link: "/unaffected/bowel",
                text: "Bowel cancer",
                properties: {
                    color: 'violet',
                    fluid: true
                }
            },
            {
                link: "/unaffected/prostate",
                text: "Prostate cancer",
                properties: {
                    color: 'blue',
                    fluid: true
                }
            },
            {
                link: "/unaffected/endometrial",
                text: "Endometrial cancer",
                properties: {
                    color: 'teal',
                    fluid: true
                }
            }

        ]
    });
}

export default UnaffectedCancerType;
